import { render, staticRenderFns } from "./TypographyShadesAndOpacitySection.vue?vue&type=template&id=31fd57a5"
import script from "./TypographyShadesAndOpacitySection.vue?vue&type=script&lang=ts"
export * from "./TypographyShadesAndOpacitySection.vue?vue&type=script&lang=ts"
import style0 from "./TypographyShadesAndOpacitySection.vue?vue&type=style&index=0&id=31fd57a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports